
import { useAuthStore } from '../../stores/auth';
import { storeToRefs } from 'pinia';
import { useWebStore } from '../../stores/web';
import Message from 'primevue/message';

export default {
	name: 'BannerDownload',
	components: {
		Message,
	},
	setup() {
		const auth = useAuthStore()
		auth.hydrate()
		const {profile, isLoggedIn} = storeToRefs(auth);

		const web = useWebStore();
		web.hydrate()

		return {
		}
	}
}
